'use client';

import type { Table } from '@tanstack/react-table';
import { Pagination } from '@zealot/ui/components/pagination';

type DataTablePaginationProps<TData> = {
  table: Table<TData>;
  pageSizeOptions?: number[];
  showSelectedCount?: boolean;
  className?: string;
};

const DataTablePagination = <TData,>({
  table,
  pageSizeOptions,
  showSelectedCount = false,
  className,
}: DataTablePaginationProps<TData>) => {
  const { pageIndex, pageSize } = table.getState().pagination;
  const isTotalKnown = table.options.rowCount != null || !table.options.manualPagination;

  return (
    <Pagination
      page={pageIndex + 1}
      pageCount={table.getPageCount()}
      onPageChange={(page) => table.setPageIndex(page - 1)}
      total={isTotalKnown ? table.getRowCount() : undefined}
      pageSize={pageSize}
      pageSizeOptions={pageSizeOptions}
      onPageSizeChange={table.setPageSize}
      summary={
        showSelectedCount ? (
          <>
            {table.getFilteredSelectedRowModel().rows.length} of {table.getFilteredRowModel().rows.length} selected
          </>
        ) : undefined
      }
      className={className}
    />
  );
};

export type { DataTablePaginationProps };
export { DataTablePagination };
